/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCreateRequestItemsSchema } from "./banquetCreateRequestItemsSchema.ts";

export const orgOrganizationsDecorationRetrievePathOrgIdSchema = z.uuid();

export const orgOrganizationsDecorationRetrieveStatus200Schema = banquetCreateRequestItemsSchema;

export const orgOrganizationsDecorationRetrieveResponseSchema = orgOrganizationsDecorationRetrieveStatus200Schema;
